import React, { useState, useEffect } from "react";
import { Link } from "react-router";
import axios from "axios";

import Pagination from "../../components/Pagination";
import DebouncedInput from "../../components/DebouncedInput";
import Filter from "../../components/Filter";

export default function AuditOverview() {
    const [search, setSearch] = useState("");
    const [filterTrainers, setFilterTrainers] = useState([]);
    const [filterAuditors, setFilterAuditors] = useState([]);
    const [activeFilters, setActiveFilters] = useState({});
    const [events, setEvents] = useState([]);
    const [count, setCount] = useState(0);
    const [limit, setLimit] = useState(0);
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        getFilterTrainers();
        getFilterAuditors();
        getResults(0);
    }, []);

    useEffect(() => {
        getResults(0);
    }, [activeFilters, search]);

    const getResults = async (offset) => {
        const params = new URLSearchParams({ offset });
        if (search) {
            params.set("search", search);
        }

        try {
            const response = await axios.get(`/v1/audits/?${params}`, {
                params: {
                    ...activeFilters
                }
            });

            setEvents(response.data.results);
            setCount(response.data.count);
            setLimit(response.data.limit);
            setOffset(response.data.offset);
        } catch (error) {
            console.error(error);
        }
    };

    const handleFilter = (name, value) => {
        const newState = { ...activeFilters };
        newState[name] = value;

        setActiveFilters(newState);
    };

    const getFilterTrainers = async () => {
        try {
            const response = await axios.get("/v1/trainers/?fields=uuid,name&pagination=false");

            let filterTrainers = [
                ...response.data.map((item) => {
                    return {
                        value: item.uuid,
                        name: item.name
                    };
                })
            ];

            setFilterTrainers(filterTrainers);
        } catch (error) {
            console.error(error);
        }
    };

    const getFilterAuditors = async () => {
        try {
            const response = await axios.get("/v1/users/?roles=auditor&fields=uuid,full_name&pagination=false");

            let filterAuditors = [
                ...response.data.map((item) => {
                    return {
                        value: item.uuid,
                        name: item.full_name
                    };
                })
            ];

            setFilterAuditors(filterAuditors);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            <div className="section-top">
                <h1>Controles</h1>
            </div>
            <div className="row">
                <div className="col-3 filters audits-filters">
                    <Filter
                        className="line-height-dropdown-fixed"
                        title="Opleider"
                        type="dropdown"
                        placeholder="Selecteer een optie"
                        filterName="trainer"
                        filters={filterTrainers}
                        handleFilter={(name, value) => handleFilter(name, value)}
                        activeFilters={activeFilters}
                    />
                    <Filter
                        className="controller-dropdown line-height-dropdown-fixed"
                        title="Controleur"
                        type="dropdown"
                        placeholder="Selecteer een optie"
                        filterName="auditor"
                        filters={filterAuditors}
                        handleFilter={(name, value) => handleFilter(name, value)}
                        activeFilters={activeFilters}
                    />
                </div>
                <div className="col-9">
                    <div className="filter-text-wrapper">
                        <div className="filter-block">
                            <DebouncedInput type="text" className="filter-text" placeholder="Zoeken" initialValue={search} onChange={(value) => setSearch(value)} />
                            <i className="fa fa-search"></i>
                        </div>
                    </div>

                    {events ? (
                        <table className="table table-hover table-clickable">
                            <thead>
                                <tr>
                                    <th>Cursus</th>
                                    <th>Toetsmoment</th>
                                    <th>Opleider</th>
                                    <th>Datum</th>
                                    <th>Controleur</th>
                                </tr>
                            </thead>
                            <tbody>
                                {events.map((event) => (
                                    <tr key={event.uuid}>
                                        <td>{event.course.id}</td>
                                        <td>
                                            <Link to={`/audits/${event.uuid}`}>{event.name}</Link>
                                        </td>
                                        <td>{event.trainer.name}</td>
                                        <td>{event.start_datetime}</td>
                                        <td>
                                            {event.event_roles.map((role) => (
                                                <React.Fragment key={role.auditor?.uuid}>
                                                    {role.auditor?.full_name}
                                                    <br />
                                                </React.Fragment>
                                            ))}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className="spinner-border spinner-border-sm float-right" role="status">
                            <span className="sr-only">Bezig met laden...</span>
                        </div>
                    )}

                    {events && <Pagination count={count} limit={limit} offset={offset} pageSwitch={(i) => getResults(i)} />}
                </div>
            </div>
        </>
    );
}
